import { mapGetters } from 'vuex'
import * as getters from '../../../store/modules/getters'
import LayoutBreadcrumb from '../../editor/LayoutBreadcrumb.vue'

export default {
  name: 'ConvrrtEditorLayout',
  components: {
    LayoutBreadcrumb,
  },
  props: {
    showLeftSideBar: {
      type: Boolean,
      require: true,
      default: true,
    },
    showEditorControls: {
      type: Boolean,
      require: true,
      default: true,
    },
    isGridBuilder: {
      type: Boolean,
      require: true,
      default: true,
    },
  },
  computed: {
    ...mapGetters({
      advanceSideBarOpen: getters.ADVANCED_MENU_OPEN,
    }),
    contentStyle() {
      return {
        gridbuilder: this.isGridBuilder,
        oldbuilder: !this.isGridBuilder,
        'layout-style-1-with-controls': this.showEditorControls && this.showLeftSideBar,
        'layout-style-2-with-controls ml-3': this.showEditorControls && !this.showLeftSideBar,
        'layout-plain': !this.showEditorControls,
      }
    },
    layoutStyles() {
      return {
        'layout-style-2': this.showEditorControls && !this.showLeftSideBar,
        'layout-style-1':
          (this.showEditorControls && this.showLeftSideBar) ||
          (!this.showEditorControls && !this.showLeftSideBar),
        'has-sidebar': this.isGridBuilder || this.advanceSideBarOpen,
      }
    },
  },
}
